import { render, staticRenderFns } from "./MerchantItem.vue?vue&type=template&id=c92844c8&scoped=true"
import script from "./MerchantItem.vue?vue&type=script&lang=js"
export * from "./MerchantItem.vue?vue&type=script&lang=js"
import style0 from "./MerchantItem.vue?vue&type=style&index=0&id=c92844c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92844c8",
  null
  
)

export default component.exports